import moment from 'moment'
import { Expose, Transform, Type } from 'class-transformer'
import { AlertCircle } from 'react-feather'

import { ASN } from './ASN'
import { Batch } from './Batch'
import { Container } from './Container'
import { Client } from './Client'
import { Facility } from './Facility'
import { Place } from './Place'
import { Product } from './Product'
import { Sku } from './Sku'

enum Damage {
  crushed = 'crushed',
  dropped = 'dropped',
  forked = 'forked',
  torn = 'torn',
}

export class Damaged {
  static type = 'damaged'
  static typeDisplay = 'Damaged'
  static icon = AlertCircle

  type = Damaged.type
  typeDisplay = Damaged.typeDisplay
  icon = Damaged.icon

  guid: string = ''

  @Type(() => Client)
  client?: Client

  @Type(() => Facility)
  facility?: Facility

  @Type(() => ASN)
  asn?: ASN

  @Type(() => Place)
  place?: Place

  @Type(() => Container)
  container?: Container

  get location() {
    return this.place || this.container || null
  }

  @Type(() => Product)
  product?: Product

  @Type(() => Sku)
  sku?: Sku

  @Type(() => Batch)
  batch?: Batch

  damage?: Damage

  @Expose({ name: 'by_us' })
  byUs: boolean = false

  notes: string = ''

  @Expose({ name: 'damaged_on' })
  @Transform((value) => (value ? moment(value) : value))
  damagedOn?: moment.Moment

  @Expose({ name: 'created_on' })
  @Transform((value) => moment(value))
  createdOn: moment.Moment = moment()

  @Expose({ name: 'updated_on' })
  @Transform((value) => moment(value))
  updatedOn: moment.Moment = moment()

  static Damage = Damage

  get damagedBy() {
    if (this.byUs) {
      return 'Warehouse Staff'
    } else {
      return '3rd Party'
    }
  }

  get name() {
    return `!!${this.guid} ${this.product?.name}`
  }

  get path() {
    if (this.location) {
      return this.location.path
    }
    return null
  }

  get objPath() {
    if (this.location) {
      return this.location.objPath
    }
    return []
  }
}
